import { v4 as uuid } from "uuid";

export const homeTemplate = () => ([
  {
    id: uuid(),
    layout: "single",
    columns: {
      col1: [
        {
          id: uuid(),
          type: "text",
          data: { text: "Bem-vindo à nossa plataforma" },
        },
        {
          id: uuid(),
          type: "button",
          data: { label: "Começar agora", url: "/cadastro" },
        },
      ],
    },
  },
  {
    id: uuid(),
    layout: "three",
    columns: {
      col1: [{ id: uuid(), type: "text", data: { text: "Cursos" } }],
      col2: [{ id: uuid(), type: "text", data: { text: "Certificados" } }],
      col3: [{ id: uuid(), type: "text", data: { text: "Comunidade" } }],
    },
  },
]);

export const landingTemplate = () => ([
  {
    id: uuid(),
    layout: "two",
    columns: {
      col1: [
        {
          id: uuid(),
          type: "text",
          data: { text: "Transforme sua carreira hoje" },
        },
        {
          id: uuid(),
          type: "button",
          data: { label: "Inscreva-se", url: "/cadastro" },
        },
      ],
      col2: [
        {
          id: uuid(),
          type: "image",
          data: {},
        },
      ],
    },
  },
]);

export const courseTemplate = () => ([
  {
    id: uuid(),
    layout: "single",
    columns: {
      col1: [
        {
          id: uuid(),
          type: "text",
          data: { text: "Sobre o curso" },
        },
        {
          id: uuid(),
          type: "html",
          data: { html: "<ul><li>Módulo 1</li><li>Módulo 2</li></ul>" },
        },
      ],
    },
  },
]);

export const forumTemplate = () => ([
  {
    id: uuid(),
    layout: "single",
    columns: {
      col1: [
        {
          id: uuid(),
          type: "forum",
          data: {},
        },
      ],
    },
  },
]);
